import { Component, computed, inject } from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';
import { Router, RouterOutlet } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { LOADING } from './core/services/loading.service';
import { APP_INSIGHTS } from './shared/logging/appinsights.factory';

@Component({
	selector: 'lvr-root',
	imports: [RouterOutlet, TranslocoModule, MatProgressBar],
	templateUrl: './app.html',
	styleUrl: './app.scss',
})
export class App {
	private readonly loading = inject(LOADING);
	private readonly router = inject(Router);
	public readonly isNavigating = computed(() => {
		const navigation = this.router.currentNavigation();
		return !!navigation;
	});
	public readonly isLoading = this.loading.isCurrentlyLoading();

	protected title = 'KlifdWeb';

	private readonly insights = inject(APP_INSIGHTS);

	public constructor() {
		this.insights.trackPageView({ name: 'App Loaded' });
	}
}
